import { PasscodeValidationError } from 'components/settings/EditPasscodeDialog';
import { noop } from 'es-toolkit';
import AppConstants from 'constants/AppConstants';
import protos from 'utils/protos';

const { PatronPasscode } = protos;

/**
 * Update a patron's passcode.
 *
 * @param {number} patronId
 * @param {string} passcode
 * @returns {Object} A redux TockApi action.
 */
export function upsert(patronId: number, passcode: string): ApiAction {
  const request = PatronPasscode.fromObject({ patronId, passcode });

  return {
    TockApi: {
      postProto: `/admin/patron/${patronId}/passcode`,
      type: AppConstants.PATRON_PASSCODES_UPSERT,
      request,
      toast: 'Passcode updated',
      onError: {
        // Modal will display validation errors.
        [PasscodeValidationError.BAD_REQUEST_PASSCODE_DUPLICATE]: noop,
        [PasscodeValidationError.BAD_REQUEST_PASSCODE_INVALID_LENGTH]: noop,
        [PasscodeValidationError.BAD_REQUEST_PASSCODE_CONSECUTIVE_DIGITS]: noop,
        [PasscodeValidationError.BAD_REQUEST_PASSCODE_REPEATED_DIGITS]: noop,
        defaultToOriginal: true,
      },
    },
  };
}

/**
 * Remove a patron's passcode
 */
export function remove(patronId: number): ApiAction {
  return {
    TockApi: {
      deleteProto: `/admin/patron/${patronId}/passcode`,
      type: AppConstants.PATRON_PASSCODES_DELETE,
      toast: 'Passcode removed',
      context: { patronId },
    },
  };
}

/**
 * Fetch all passcodes for patrons within the current business.
 *
 * @returns {Object} A redux TockApi action.
 */
export function fetchPasscodes(): ApiAction {
  return {
    TockApi: {
      getListProto: '/admin/business/passcode',
      type: AppConstants.PATRON_PASSCODES_FETCH,
    },
  };
}
